import { createAppRequest } from '@/services/request';
import type { EmployeePortalEffectiveFeatures } from '@/permissions/employeePortalFeatures';

const request = createAppRequest();

export const getMyEmployeePortalEffectiveFeatures = () =>
  request<EmployeePortalEffectiveFeatures>(
    '/bff/zy-hr/employee-portal/effective-features',
    { method: 'GET' },
  );
